export default __webpack_public_path__ + "static/media/circleChat.12d86dbc.svg";